// Assets carry their image URL under one of two keys depending on when the drop was created:
// `url` for uploads stored raw (current), `desktop`/`mobile` for the legacy pre-resized variants.
// Returns the stored value as-is; callers add the protocol (server: addHttpsProtocol,
// client: buildAssetUrl).
export function getDropAssetImageUrl(asset) {
    var _a, _b;
    if (!asset) {
        return undefined;
    }
    // Legacy records could hold the drop's trailer as an asset. removeYouTubeAssetTypeMigration
    // cleared those, but an untyped `url` is not proof of an image, so keep the guard.
    if ('type' in asset && asset.type === 'youtubeURL') {
        return undefined;
    }
    return (_b = (_a = asset.desktop) !== null && _a !== void 0 ? _a : asset.url) !== null && _b !== void 0 ? _b : asset.mobile;
}
export function getDropAssetImageUrls(assets) {
    return (assets !== null && assets !== void 0 ? assets : []).flatMap((asset) => {
        const url = getDropAssetImageUrl(asset);
        return url ? [url] : [];
    });
}
